import type { HTMLAttributes } from 'react';

export type CartLineItemImageProps = HTMLAttributes<HTMLImageElement> & {
  /**
   *
   */
  src: string;
  alt: string;
  width: number;
  height: number;
  lazy?: boolean;
};

/**
 * @TODO support usage with Next & Cloudinary's React SDK Image components, whether that's new components or supported here
 * Note: In Firefox there is an issue, the loading attribute must be defined before the src attribute,
 * otherwise it has no effect: http://tinyurl.com/th5v633a
 */
export const CartLineItemImage = ({ className, src, alt, width, height, lazy = false, ...rest }: CartLineItemImageProps) => {
  return (
    <img
      className={className}
      loading={lazy ? 'lazy' : undefined}
      src={src}
      alt={alt}
      width={width}
      height={height}
      {...rest}
    />
  );
};
